import type { Product } from '@/entities/product/config';
import { apiClient } from '@/shared/api';

export interface FavoritesListResponse {
  products: Product[];
}

export interface ProductsByIdsRequest {
  ids: number[];
}

export async function getFavoritesApi(): Promise<FavoritesListResponse> {
  return await apiClient<FavoritesListResponse>('favorites', {
    method: 'GET',
  });
}

export async function getProductsByIdsApi(
  payload: ProductsByIdsRequest,
): Promise<FavoritesListResponse> {
  return await apiClient<FavoritesListResponse>('products/by-ids', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function addFavoriteApi(productId: number): Promise<void> {
  await apiClient('favorites', {
    method: 'POST',
    body: JSON.stringify({ product_id: productId }),
  });
}

export async function removeFavoriteApi(productId: number): Promise<void> {
  await apiClient(`favorites/${productId}`, {
    method: 'DELETE',
  });
}

export async function syncFavoritesApi(productIds: number[]): Promise<void> {
  await apiClient('favorites/sync', {
    method: 'POST',
    body: JSON.stringify({ product_ids: productIds }),
  });
}
